import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const ADD_LEDGERS = 'ADD_LEDGERS'
const ADD_LEDGER_TO_STACK = 'ADD_LEDGER_TO_STACK'
const DELETE_LEDGER_FROM_STACK = 'DELETE_LEDGER_FROM_STACK'
const EDIT_LEDGER_IN_STACK = 'EDIT_LEDGER_IN_STACK'
const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createLedger: '+ ADD_LEDGERS)

const ledger_obj = {
    namespaced: true,
    state: {
        ledger: []
    },
    mutations: {
        ADD_LEDGERS (state, data) {
            state.ledger = state.ledger.concat(data)
        },
        ADD_LEDGER_TO_STACK (state, ledger_obj) {
            state.ledger.unshift(ledger_obj)
        },
        DELETE_LEDGER_FROM_STACK (state, ledger_obj) {
            if (state.ledger.length) {
                let i = state.ledger.map(ledger_obj => ledger_obj.id).indexOf(ledger_obj.id)
                state.ledger.splice(i, 1)
            }
        },
        EDIT_LEDGER_IN_STACK (state, ledger_obj) {
            if (state.ledger.length) {
                let i = state.ledger.map(ledger_obj => ledger_obj.id).indexOf(ledger_obj.id)
                Vue.set(state.ledger, i, ledger_obj)
            }
        },
        LOGOUT_USER (state) {
            state.ledger = []
        }
    },
    getters: {
        ledger (state) {
            return state.ledger
        }
    },
    actions: {
        // API Calls
        async getUsersLedger ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('ledger', {params: {sort: data.sort, order: data.order, page: data.page, limit: data.limit, type: data.type}})
                commit(ADD_LEDGERS, response.data)
                //console.log('getUsersLedger: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getLedger ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLedger data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('ledger/showByOrder/' + data)
                //console.log('getLedger response.data: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getUserBalance ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLedger data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('ledger/showUserBalance/' + data)
                //console.log('getUserBalance response.data: ', response.data)
                //commit(ADD_LEDGERS, response.data)
                return response.data
            } catch (error) {
                throw error
            }
        },


        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
        async addLedgerToStack ({ dispatch, commit, getters, rootGetters }, ledger_obj) {
            try {
                commit(ADD_LEDGER_TO_STACK, ledger_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async deleteLedgerFromStack ({ dispatch, commit, getters, rootGetters }, ledger_obj) {
            try {
                commit(DELETE_LEDGER_FROM_STACK, ledger_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async editLedgerInStack ({ dispatch, commit, getters, rootGetters }, ledger_obj) {
            try {
                commit(EDIT_LEDGER_IN_STACK, ledger_obj)
            } catch (error) {
                throw new Error(error)
            }
        }
    }
}

export default ledger_obj
